import { GeneratedType } from "@cosmjs/proto-signing";
import { MsgSubmitEvidence } from "./types/cosmos/evidence/v1beta1/tx";

const msgTypes: Array<[string, GeneratedType]>  = [
    ["/cosmos.evidence.v1beta1.MsgSubmitEvidence", MsgSubmitEvidence],
    
];

export { msgTypes }